// @flow

import { JWTPermissionProvider, PermissionProvider } from "@quantum/permission";
import * as React from "react";
import { useSelector } from "react-redux";

import { getJWTExcel } from "../../state";

export const ProvedorDePermissionamentoExcel = (props: *) => {
  const jwt = useSelector(getJWTExcel);
  return jwt ? (
    <JWTPermissionProvider jwt={jwt} {...props} />
  ) : (
    <PermissionProvider {...props} />
  );
};
